import EnteredDataSection from '@shared/components/EnteredDataSection';

const GuestDetail = ({ copyPassenger }) => {
  const fieldsList = copyPassenger.map(passenger => ({
    Huésped: `${passenger.passengerSequence}`,
    Tipo:
      {
        1: 'Adulto',
        2: 'Menor',
        3: 'Infante',
      }[passenger.passengerType] || 'Desconocido',
    Nombre: passenger.nombre,
    Apellido: passenger.apellido,
    'DNI - Pasaporte': passenger.numerodedocumento,
  }));

  return (
    <EnteredDataSection title="Datos Ingresados" fieldsList={fieldsList} />
  );
};

export default GuestDetail;
